// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $Model,
} from 'common.data';

// Global Components
import * as React from 'react';
import {
  Col,
  Row,
} from 'reactstrap';
import {
  AvField,
} from 'availity-reactstrap-validation';

// Types
type $OptionalProps = {
  onChange?: () => unknown;
};

type $Props = $OptionalProps & $Translate & {
  item: $Model<'Admin'>;
};

type $State = {
  newPasswordValue: string;
};

class ProfileFieldsView extends React.Component<$Props, $State> {
  static defaultProps: $OptionalProps = {
    onChange: undefined,
  };

  constructor(props: $Props) {
    super(props);

    this.state = {
      newPasswordValue: '',
    };
  }

  render() {
    const {
      item,
      onChange,
      t,
    } = this.props;
    const {
      newPasswordValue,
    } = this.state;

    const password: boolean = newPasswordValue !== '';

    return (
      <>
        <Row>
          <Col>
            <AvField
              label={t('Name')}
              name={'Name'}
              onChange={onChange}
              required
              value={item.Name}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <AvField
              disabled
              email
              label={t('Email')}
              name={'Email'}
              onChange={onChange}
              value={item.Email}
            />
          </Col>
          <Col>
            <AvField
              label={t('Phone')}
              name={'Phone'}
              onChange={onChange}
              value={item.Phone}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <AvField
              label={t('New password')}
              name={'NewPassword'}
              onChange={(e) => {
                if (onChange) {
                  onChange();
                }

                this.setState({
                  newPasswordValue: e.target.value,
                });
              }}
              required={password}
              type={'password'}
            />
          </Col>
          <Col>
            <AvField
              disabled={!password}
              label={t('Old password')}
              name={'OldPassword'}
              onChange={onChange}
              required={password}
              type={'password'}
            />
          </Col>
        </Row>
      </>
    );
  }
}

export default ProfileFieldsView;
